/**
 * File onetrust.js.
 * Replace OneTrust nav item with OneTrust button
 * Display message when Youtube video is blocked
 */

const oneTrustNavItem = document.querySelector('.onetrust-btn__menu-item');
if (oneTrustNavItem) oneTrustNavItem.innerHTML = "<a id='ot-sdk-btn' class='ot-sdk-show-settings' tabindex='0'>Do Not Sell or Share My Personal Information</a>";
